<!--  -->
<template>
  <div class="api-menu">
    <b-navbar
      :toggleable="false"
      type="light"
      variant="white"
      class="custom-navbar vertical-navbar"
    >
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="flex-column">
          <!-- 一级菜单项 -->
          <b-nav-item
            v-for="(item, index) in menuItems"
            :key="item.id"
            :class="{
              'has-children': item.children && item.children.length > 0,
              active: isActive(item),
            }"
            @click="handleClick(index, item, $event)"
            class="main-menu-item w-100"
          >
            <div class="nav-item-content d-flex align-items-center">
              <!-- 一级菜单图标 -->
              <b-icon
                v-if="item.icon"
                :icon="item.icon"
                class="menu-icon mr-2"
              ></b-icon>
              <span class="menu-label tw-py-3 tw-px-3 flex-grow-1">{{
                $t(item.name)
              }}</span>
              <!-- 二级菜单展开/收起图标 -->
              <b-icon
                v-if="item.children && item.children.length > 0"
                :icon="
                  activeMenuIndex === index ? 'chevron-up' : 'chevron-down'
                "
                class="arrow-icon ml-auto"
              ></b-icon>
            </div>

            <!-- 二级菜单 -->
            <b-collapse
              v-if="item.children && item.children.length > 0"
              :visible="activeMenuIndex === index"
              class="submenu-collapse"
            >
              <b-navbar-nav class="submenu flex-column">
                <b-nav-item
                  v-for="child in item.children"
                  :key="child.id"
                  @click.stop="handleClick(undefined, child)"
                  class="submenu-item w-100"
                  :class="{ active: $route.path.startsWith(child.path) }"
                >
                  <!-- 二级菜单不显示图标，只显示文字 -->
                  <span>{{ $t(child.name) }}</span>
                </b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
export default {
  name: "api-menu",
  props: {},
  components: {},
  data() {
    return {
      // 当前展开的菜单索引，-1表示没有展开的菜单
      activeMenuIndex: -1,
      // 菜单数据（一级菜单带图标）
      menuItems: [
        {
          id: 1,
          name: "控制台",
          path: "/apiWord/api-console",
          // icon: "terminal",
        },
        {
          id: 2,
          name: "安全设置",
          path: "/apiWord/security-settings",
          // icon: "gear",
          children: [
            { id: 21, name: "谷歌验证", path: "/apiWord/google-verification" },
            { id: 22, name: "白名单列表", path: "/apiWord/whitelist-list" },
          ],
        },
        {
          id: 3,
          name: "钱包管理",
          path: "/apiWord/wallet-management",
          // icon: "wallet",
          children: [
            {
              id: 31,
              name: "交易回调",
              path: "/apiWord/transaction-pullback",
            },
            { id: 32, name: "资产管理", path: "/apiWord/assets-management" },
            { id: 33, name: "合约监听", path: "/apiWord/contract-monitoring" },
          ],
        },
        {
          id: 4,
          name: "币种管理",
          path: "/apiWord/currency-management",
          // icon: "layers",
          children: [
            { id: 41, name: "币种列表", path: "/apiWord/currency-list" },
            { id: 42, name: "上币申请", path: "/apiWord/currency-apply" },
            { id: 43, name: "上币记录", path: "/apiWord/currency-record" },
          ],
        },
        {
          id: 5,
          name: "充币/提币管理",
          path: "/apiWord/deposit-management",
          // icon: "coin",
          children: [
            { id: 51, name: "充币列表", path: "/apiWord/deposit-list" },
            { id: 52, name: "提币审核", path: "/apiWord/coin-audit" },
            { id: 53, name: "提币配置", path: "/apiWord/coin-configuration" },
          ],
        },
        {
          id: 6,
          name: "生成地址",
          path: "/apiWord/generated-address",
          // icon: "pin-map",
        },
        // {
        //   id: 7,
        //   name: "WEB3工具",
        //   path: "/apiWord/web3-tools",
        //   // icon: "slack",
        //   children: [
        //     {
        //       id: 71,
        //       name: "批量生成钱包地址",
        //       path: "/apiWord/wallet-address",
        //     },
        //   ],
        // },
        {
          id: 8,
          name: "客服",
          // icon: "headset",
          external: true,
          url: "https://t.me/BF_WEB3",
        },
      ],
    };
  },
  computed: {
    // 路径
    path() {
      return this.$route.path;
    },
  },
  watch: {
    // 路由变化时自动展开对应菜单
    $route: {
      handler(to) {
        const newIndex = this.menuItems.findIndex((item) =>
          item.children?.some((child) => to.path.startsWith(child.path))
        );
        if (newIndex !== this.activeMenuIndex) {
          this.$nextTick(() => {
            this.activeMenuIndex = newIndex;
          });
        }
      },
      immediate: true, // 初始化时立即执行
    },
  },
  created() {},
  methods: {
    // 统一判断菜单是否激活
    isActive(item) {
      // 一级菜单激活条件：自身路径匹配或包含激活的子菜单
      return (
        this.$route.path.startsWith(item.path) ||
        item.children?.some((child) => this.$route.path.startsWith(child.path))
      );
    },

    // 统一处理所有菜单点击
    handleClick(index, item, clickEvent) {
      // 处理外部链接
      if (item.external) {
        window.open(item.url, "_blank");
        return;
      }
      // 处理有子菜单的一级菜单（展开/收起）
      if (item.children?.length && index !== undefined) {
        clickEvent?.stopPropagation();
        const hasActiveChild = item.children.some((child) =>
          this.$route.path.startsWith(child.path),
        );

        // 首次进入该一级目录时，直接打开第一个二级页面，减少一次点击。
        if (!hasActiveChild) {
          this.activeMenuIndex = index;
          const firstChild = item.children[0];
          if (firstChild?.path && this.$route.path !== firstChild.path) {
            this.$router.push(firstChild.path);
          }
          return;
        }

        // 已经位于当前目录下时，一级目录只控制展开和收起。
        this.activeMenuIndex = this.activeMenuIndex === index ? -1 : index;
      }
      // 处理无二级菜单的点击（路由跳转）
      else if (item.path && this.$route.path !== item.path) {
        this.$router.push(item.path);
        // 只有一级菜单跳转后才收起菜单，二级菜单保持展开状态
        if (index !== undefined) {
          this.activeMenuIndex = -1;
        }
      }
    },
  },
};
</script>

<style src="./api-menu.scss" lang="scss" scoped></style>
